//inviewport
$.fn.isOnScreen = function () {

    var $W = $(window);

    var viewport = {
        top: $W.scrollTop(),
        left: $W.scrollLeft(),
    };

    viewport.right = viewport.left + $W.width();
    viewport.bottom = viewport.top + $W.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    var marginX = Math.floor(document.body.clientWidth/2) || 700;
    var marginY = Math.floor(document.body.clientHeight/2) || 400;


    return (!(viewport.right < bounds.left - marginX || viewport.left > bounds.right + marginX || viewport.bottom < bounds.top - marginY || viewport.top > bounds.bottom + marginY ));

};

var checkInVP = function () {
    $('._js_inViewport').each(function () {
        if ($(this).isOnScreen()) {
            $(this).addClass('__js_onScreen');
            $(this).removeClass('_js_inViewport');
        }
    });

    setTimeout(checkInVP, 690);
};
setTimeout(checkInVP, 690);